<template lang="pug">
input.TextInput.TextInput--block(
  :value='value',
  :class='{ "TextInput--error": hasError, "TextInput--warning": hasWarning }',
  type='text',
  :placeholder='placeholder || ""',
  @input='handleInput'
)
</template>

<script>
export default {
  name: 'TextBox',

  props: {
    /**Текущее значение */
    value: String,

    /**Status */
    hasError: Boolean,
    hasWarning: Boolean,

    placeholder: String
  },

  model: {
    prop: 'value',
    event: 'valueChanged'
  },

  methods: {
    handleInput(event) {
      this.$emit('valueChanged', event.target.value)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~base';
</style>



// WEBPACK FOOTER //
// src/components/TextBox.vue